import { getImageFields } from '@utils';
import { IMG_TYPES } from '@atoms/Img';

export default ({ pictures }) => ({
  pictures: pictures.map((picture) => ({
    ...getImageFields(picture, IMG_TYPES.fixed),
    id: picture.id,
  })),
});
